<template>
  <div class="util-latest-list">
    <div class="util-card" v-for="(row,i) in listdata" :key="i">
      <div class="util-card-date">
        <strong>{{ dayjs(row.date).format("D") }}</strong>
        <span>{{ dayjs(row.date).format("MMM") }}</span>
        <span>{{ dayjs(row.date).format("YYYY") }}</span>
      </div>
      <div class="util-card-detail ucdg">
        <div class="ucdg-item">
          <span>Total Produksi</span>
          <p>
            <strong>{{ num(row.production_total ?? '0') }}</strong> Box
          </p>
        </div>
        <div class="ucdg-item">
          <span>Biaya Listrik</span>
          <p class="pgreen"> 
            <strong>{{ num(Math.floor(row.cost?.cost_electric) ?? '0') }}</strong>
          </p>
        </div>
        <div class="ucdg-item">
          <span>Biaya Gas</span>
          <p class="pgreen"> 
            <strong>{{ num(Math.floor(row.cost?.cost_gas) ?? '0') }}</strong>
          </p>
        </div>
        <div class="ucdg-item">
          <span>Biaya Air</span>
          <p class="pgreen"> 
            <strong>{{ num(Math.floor(row.cost?.cost_water) ?? '0') }}</strong>
          </p>
        </div>
        <!-- <div class="ucdg-item">
          <span>Biaya Per Box</span>
          <p class="pgreen"> 
            <strong>{{ num(Math.floor(row.cost?.cost_per_cake) ?? '0') }}</strong>
          </p>
        </div> -->
        <div class="ucdg-item">
          <span>Total Biaya</span>
          <p class="pgreen"> 
            <strong>{{ num(Math.floor(row.cost?.total_biaya) ?? '0') }}</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="js">
import Vue from "vue";
import dayjs from "dayjs";
import { Prop } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import { num  } from "@/api/api";
@Component({})
export default class UtilitiesListrikList extends Vue {
  @Prop () listdata;
  dayjs = dayjs
  num = num
}
</script>
